import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-105">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-106">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium mb-8" data-id="element-107">
              <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" data-id="element-108"></span>
              KI-gestützte Visualisierung
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight text-white leading-[1.1] mb-8" data-id="element-109">
              Immobilien sehen, bevor sie fertig sind
            </h1>
            <p className="text-xl font-light text-zinc-400 leading-relaxed mb-10 max-w-lg" data-id="element-110">
              Hyperrealistische KI-Visualisierungen für Homestaging, Fassaden
              und Vermarktung – schnell, skalierbar, premium.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-111">
              <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-112">
                Projekt anfragen
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-113" />
              </Button>
              <Button variant="secondary" size="lg" onClick={() => document.getElementById('gallery')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-114">
                Beispiele ansehen
              </Button>
            </div>
          </div>

          {/* Hero Visual with Animated Gradient Border */}
          <div className="relative lg:h-[600px] w-full" data-id="element-115">
            <div className="animated-gradient-border h-full" data-id="element-116">
              <div className="animated-gradient-border-inner overflow-hidden" data-id="element-117">
                <div className="w-full h-full relative min-h-[400px] lg:min-h-0" data-id="element-118">
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out hover:scale-105" style={{
                  backgroundImage: "url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2653&auto=format&fit=crop')"
                }} data-id="element-119"></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent" data-id="element-120"></div>

                  {/* Floating Badge */}
                  <div className="absolute bottom-8 left-8 glass-card px-6 py-4 rounded-lg" data-id="element-121">
                    <p className="text-xs font-medium text-blue-400 uppercase tracking-wider mb-1" data-id="element-122">
                      Rendering Preview
                    </p>
                    <p className="text-sm font-medium text-white" data-id="element-123">
                      Villa K, München
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Glow */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500/20 rounded-full blur-[120px]" data-id="element-124"></div>
          </div>
        </div>
      </div>
    </section>;
}